import { combineReducers } from 'redux';
import {createBrowserHistory} from 'history';
import { connectRouter } from 'connected-react-router';
import actions from './actions';
import App from './app/reducer';
import Auth from './auth/reducer';
import LanguageSwitcher from './languageSwitcher/reducer';
import SystemInfos from './systemInfos/reducer';

const history = createBrowserHistory();
const routerReducer = connectRouter(history);

const combinedReducers = combineReducers({
  App,
  Auth,
  LanguageSwitcher,
  SystemInfos,
  router: routerReducer,
});
const appReducer = (state, action) => {
  if (action.type === actions.RESET_APP) {
    state = undefined;
  }

  return combinedReducers(state, action);
}

export default appReducer;
